import { render, staticRenderFns } from "./ContextMenu.vue?vue&type=template&id=0bf1f41e&scoped=true"
import script from "./ContextMenu.vue?vue&type=script&lang=js"
export * from "./ContextMenu.vue?vue&type=script&lang=js"
import style0 from "./ContextMenu.vue?vue&type=style&index=0&id=0bf1f41e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf1f41e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bf1f41e')) {
      api.createRecord('0bf1f41e', component.options)
    } else {
      api.reload('0bf1f41e', component.options)
    }
    module.hot.accept("./ContextMenu.vue?vue&type=template&id=0bf1f41e&scoped=true", function () {
      api.rerender('0bf1f41e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/canvas/components/editor/ContextMenu.vue"
export default component.exports